import React from 'react';
import { Col, Row, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import './exames.styles.css';
import IntlMessage from '../../../../../../helpers/intlMessage';
import { injectIntl, useIntl } from 'react-intl';

export const ExamesPage = (props,) => {

    const intl = useIntl();

    return (
        <div className="exames-container">
            <p className="title"><IntlMessage id="dashboards.examDetail.openExam" /></p>
            {
                props.examesemaberto.length > 0 && <div style={{ height: `${props.altura - 38}px`, overflowY: 'scroll', overflowX: 'hidden' }}>
                    {
                        props.examesemaberto.map(item => {
                            return (<Row key={item.id}>
                                <Col>
                                    <Card>
                                        <Row>
                                            <Col sm={'auto'} className="informacoes-exame">
                                                <CardBody>
                                                    <CardTitle>{`${item.numeroExame} - ${item.exame}`}</CardTitle>
                                                    <CardText><IntlMessage id="dashboards.examDetail.solicted" />{`${item.medicoSolicitante}`}</CardText>
                                                    <CardTitle>{item.laudo}</CardTitle>
                                                </CardBody>
                                            </Col>
                                            <Col className="informacoes-exame">
                                                <CardBody className="informacoes-exame-body">
                                                    <ul>
                                                        {
                                                            item.etapas.filter((item) => {
                                                                return item.status !== 'naorealizado';
                                                            }).map((etapa, i) => {
                                                                let executante = etapa.medicoEtapa !== ''
                                                                    ? intl.formatMessage({ id: 'dashboards.examDetail.performedBy' }) /* `${etapa.medicoEtapa}` */
                                                                    : intl.formatMessage({ id: 'dashboards.examDetail.executed' })

                                                                let data;
                                                                if (etapa.dataEtapa !== '') {
                                                                    data = ` em ${etapa.dataEtapa}`
                                                                } else {
                                                                    executante = intl.formatMessage({ id: 'dashboards.examDetails.status.pending' }),
                                                                        data = '';
                                                                }
                                                                return (
                                                                    <li key={i}>
                                                                        <IntlMessage id="dashboards.examDetail.step" /> {`${etapa.etapa}${executante}${data}`}
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </CardBody>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>)
                        })
                    }
                </div>
            }
        </div>
    )
}

export default injectIntl(ExamesPage);


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/exames/exames.page.js